import { gkApi } from './index';

const todoApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    listTodoCategories: builder.query({
      query: () => ({
        url: '/todo-category/',
        method: 'get',
        params: { limit: 500 },
      }),
      providesTags: [{ type: 'TODO_CATEGORY' }],
    }),
    listTodos: builder.query({
      query: ({ eventId, status, mine, category } = {}) => ({
        url: '/todo/',
        method: 'get',
        params: {
          event: eventId,
          status,
          mine: mine ? 'true' : undefined,
          category,
          limit: 500,
        },
      }),
      providesTags: [{ type: 'TODO_LIST' }],
    }),
    getTodo: builder.query({
      query: (id) => ({ url: `/todo/${id}/`, method: 'get' }),
      providesTags: (_r, _e, id) => [{ type: 'TODO', id }],
    }),
    createTodo: builder.mutation({
      query: (payload) => ({
        url: '/todo/',
        method: 'post',
        body: payload,
      }),
      invalidatesTags: [{ type: 'TODO_LIST' }],
    }),
    updateTodo: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/todo/${id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'TODO_LIST' },
        { type: 'TODO', id },
      ],
    }),
    deleteTodo: builder.mutation({
      query: (id) => ({ url: `/todo/${id}/`, method: 'delete' }),
      invalidatesTags: [{ type: 'TODO_LIST' }],
    }),
    claimTodo: builder.mutation({
      query: (id) => ({ url: `/todo/${id}/claim/`, method: 'post' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'TODO_LIST' },
        { type: 'TODO', id },
      ],
    }),
    releaseTodo: builder.mutation({
      query: (id) => ({ url: `/todo/${id}/release/`, method: 'post' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'TODO_LIST' },
        { type: 'TODO', id },
      ],
    }),
    completeTodo: builder.mutation({
      query: (id) => ({ url: `/todo/${id}/complete/`, method: 'post' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'TODO_LIST' },
        { type: 'TODO', id },
      ],
    }),
  }),
});

export const {
  useListTodoCategoriesQuery,
  useListTodosQuery,
  useGetTodoQuery,
  useCreateTodoMutation,
  useUpdateTodoMutation,
  useDeleteTodoMutation,
  useClaimTodoMutation,
  useReleaseTodoMutation,
  useCompleteTodoMutation,
} = todoApi;
